import { Component, HostBinding, input, Input, output, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { IconComponent, IconName } from '@cumlaude/shared-components-icons';

type SidebarSizeClass = 'size-30-vw' | 'size-20' | 'size-22' | 'size-23' | 'size-25' | 'size-34' | 'size-44' | 'size-47';

@Component({
	selector: 'app-base-sidebar',
	templateUrl: './base-sidebar.component.html',
	styleUrl: './base-sidebar.component.scss',
	imports: [NgTemplateOutlet, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseSidebarComponent {
	@Input()
	topBarTemplate?: TemplateRef<any>;

	@Input()
	bottomBarTemplate?: TemplateRef<any>;

	@HostBinding('class')
	@Input()
	sizeClass: SidebarSizeClass = 'size-30-vw';

	noPadding = input<boolean>(false);

	icon = input<IconName | undefined>(undefined);

	sidebarTitle = input<string>();

	close = output<Event>();

	iconClick = output<Event>();
}
